/**
 * Should be used when an item is manually selected by user's input (i.e. via RC button)
 */
export const SELECTED_SIGNAL = 'selected';

/**
 * Should be used when an item is in focus
 */
export const FOCUSED_SIGNAL = 'focused';

/**
 * Should be fired when a next portion of paginated content is required by a block component
 */
export const PORTION_REQUESTED_SIGNAL = 'portionRequested';

/**
 * Used by views virtualization system, should be fired when an item becomes inactive
 */
export const INACTIVE_SIGNAL = 'inactive';

/**
 * Used by views virtualization system, should be fired when an item becomes detached
 */
export const DETACHED_SIGNAL = 'detached';

/**
 * Requests to display a SnackBar notifications
 */
export const NOTIFICATION_SIGNAL = 'notification';

/**
 * Requests to load EPG grid for a specific date
 */
export const EPG_SIGNAL = 'epg';

/**
 * Indicates some texture is loaded
 */
export const TEXTURE_LOADED_SIGNAL = 'tx_loaded';

/**
 * Requests a listener to hide common background
 */
export const HIDE_BACKGROUND_SIGNAL = 'hide_background';

/**
 * Requests a listener to display common background
 */
export const SHOW_BACKGROUND_SIGNAL = 'show_background';

/**
 * Displays a full grid by pressing a "Show More" button
 */
export const SHOW_GRID_SIGNAL = 'show_grid';

/**
 * Track items as displayed
 */
export const IMPRESSION_TRACK_SIGNAL = 'impression_track';

/**
 * Track items as hidden
 */
export const IMPRESSION_UNTRACK_SIGNAL = 'impression_untrack';
